module.exports = __webpack_public_path__ + "img/Group 26999@2x.b84b92de.png";